import { styled, Theme } from '@mui/material/styles';
import { Drawer } from '@mui/material';
import { collapsedSidebarWidth, expandedSidebarWidth } from 'constants/common';

const openedMixin = (theme: Theme) => ({
  width: expandedSidebarWidth,
  overflowX: 'hidden',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const closedMixin = (theme: Theme) => ({
  width: collapsedSidebarWidth,
  overflowX: 'hidden',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
});

export const StyledDrawer = styled(Drawer, { shouldForwardProp: prop => prop !== 'open' })(({ theme }) => ({
  width: expandedSidebarWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
      },
    },
  ],
}));
